(()=>{if(customElements.get('thiamar-scroll-collage'))return;
const clamp=(v,a=0,b=1)=>Math.min(Math.max(v,a),b);
const clampRange=(v,a,b)=>a>b?(a+b)/2:clamp(v,a,b);
const lerp=(a,b,t)=>a+(b-a)*t;
const smooth=(a,b,v)=>{if(b<=a)return v>=b?1:0;const x=clamp((v-a)/(b-a));return x*x*(3-2*x)};
class ThiamarScrollCollage extends HTMLElement{
  connectedCallback(){
    if(this._connected)return;
    this._connected=true;
    this.track=this.querySelector('.th-track');
    this.sticky=this.querySelector('.th-sticky');
    this.scene=this.querySelector('.th-scene');
    this.main=this.querySelector('[data-main]');
    this.mainImage=this.querySelector('.th-main__image');
    this.cards=[...this.querySelectorAll('[data-card]')];
    this.onScroll=this.onScroll.bind(this);
    this.measure=this.measure.bind(this);
    this.motionEnabled=this.dataset.motion!=='false'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.setMobileAspect();
    if(!this.motionEnabled){
      this.classList.add('is-static');
      this.restoreTransition();
      return;
    }
    addEventListener('scroll',this.onScroll,{passive:true});
    addEventListener('resize',this.measure,{passive:true});
    if(this.mainImage&&!this.mainImage.complete)this.mainImage.addEventListener('load',this.measure,{once:true});
    if(document.fonts?.ready)document.fonts.ready.then(()=>{if(this.isConnected)this.measure()});
    this.measure();
    requestAnimationFrame(this.measure);
  }
  disconnectedCallback(){
    removeEventListener('scroll',this.onScroll);
    removeEventListener('resize',this.measure);
    cancelAnimationFrame(this.raf);
    this._connected=false;
  }
  number(name,fallback){
    const value=parseFloat(this.dataset[name]);
    return Number.isFinite(value)?value:fallback;
  }
  findTransition(){
    if(this.transition&&this.transition.isConnected)return this.transition;
    const root=this.closest('.section-thiamar-scroll');
    this.transition=root?.querySelector('.thiamar-transition')||null;
    return this.transition;
  }
  clearTransitionLayout(transition){
    if(!transition)return;
    ['position','left','right','top','width','min-height','z-index'].forEach(prop=>transition.style.removeProperty(prop));
  }
  restoreTransition(){
    const transition=this.findTransition();
    if(!transition)return;
    if(this.contains(transition))this.after(transition);
    this.clearTransitionLayout(transition);
  }
  headerOffset(){
    const liveHeight=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height-live'));
    if(Number.isFinite(liveHeight)&&liveHeight>0&&liveHeight<innerHeight*.35)return Math.ceil(liveHeight);
    const selectors=['sticky-header','.shopify-section-header-sticky','#shopify-section-header','.header-wrapper','header'];
    for(const selector of selectors){
      const element=document.querySelector(selector);
      if(!element||element.closest('.section-thiamar-scroll'))continue;
      const style=getComputedStyle(element);
      const rect=element.getBoundingClientRect();
      if((style.position==='sticky'||style.position==='fixed')&&rect.top<=1&&rect.bottom>0&&rect.height<innerHeight*.35){
        return Math.max(0,Math.ceil(rect.bottom));
      }
    }
    return 0;
  }
  setMobileAspect(){
    const width=this.number('mobileWidth',1);
    const height=this.number('mobileHeight',width);
    if(width>0&&height>0)this.style.setProperty('--th-mobile-aspect',width+' / '+height);
  }
  mobileRatio(){
    const width=this.number('mobileWidth',1);
    const height=this.number('mobileHeight',width);
    return width>0?height/width:1;
  }
  measure(){
    if(!this.isConnected||!this.track||!this.sticky||!this.scene)return;
    const mobile=matchMedia('(max-width: 749px)').matches;
    const hostRect=this.getBoundingClientRect();
    this.viewportWidth=Math.max(hostRect.width||innerWidth,1);
    this.mobile=mobile;
    let motionDistance;
    if(mobile){
      const ratio=this.mobileRatio();
      const sceneHeight=Math.max(this.viewportWidth*ratio,1);
      const stickyTop=this.headerOffset();
      const availableHeight=Math.max(innerHeight-stickyTop,1);
      const transition=this.findTransition();
      const canPin=Boolean(transition)&&sceneHeight<=availableHeight;
      this.stageHeight=sceneHeight;
      this.style.setProperty('--th-scene-m',sceneHeight+'px');
      this.setMobileAspect();
      this.stickyHeight=sceneHeight;
      this.mobilePinned=canPin;
      if(canPin){
        this.clearTransitionLayout(transition);
        if(transition.parentNode!==this.track)this.track.appendChild(transition);
        transition.style.zIndex='1';
        this.sticky.style.position='sticky';
        this.sticky.style.top=stickyTop+'px';
        this.sticky.style.height=sceneHeight+'px';
        this.sticky.style.minHeight='0px';
        this.sticky.style.zIndex='3';
        this.scene.style.position='absolute';
        this.scene.style.inset='0px';
        this.scene.style.height='100%';
        this.track.style.height='auto';
        const naturalTransitionHeight=Math.max(Math.ceil(transition.getBoundingClientRect().height),1);
        const pace=this.number('mobilePace',85);
        const transitionScale=pace<=45 ? 1 : pace>=85 ? 2.1 : 1.5;
        transition.style.minHeight=Math.round(naturalTransitionHeight*transitionScale)+'px';
        const transitionHeight=Math.max(Math.ceil(transition.getBoundingClientRect().height),1);
        motionDistance=transitionHeight;
        this.start=this.track.getBoundingClientRect().top+scrollY-stickyTop;
      }else{
        this.restoreTransition();
        this.sticky.style.position='relative';
        this.sticky.style.top='auto';
        this.sticky.style.height=sceneHeight+'px';
        this.sticky.style.minHeight='0px';
        this.sticky.style.removeProperty('z-index');
        this.scene.style.position='relative';
        this.scene.style.inset='auto';
        this.scene.style.height=sceneHeight+'px';
        this.track.style.height=sceneHeight+'px';
        motionDistance=Math.max(sceneHeight*this.number('mobilePace',85)/100,1);
        this.start=this.track.getBoundingClientRect().top+scrollY;
      }
    }else{
      this.restoreTransition();
      this.mobilePinned=false;
      this.style.removeProperty('--th-scene-m');
      this.sticky.style.removeProperty('position');
      this.sticky.style.removeProperty('top');
      this.sticky.style.removeProperty('height');
      this.sticky.style.removeProperty('min-height');
      this.sticky.style.removeProperty('z-index');
      this.scene.style.removeProperty('position');
      this.scene.style.removeProperty('inset');
      this.scene.style.removeProperty('height');
      this.scene.style.removeProperty('bottom');
      this.track.style.removeProperty('height');
      this.stageHeight=Math.max(this.sticky.getBoundingClientRect().height||innerHeight,1);
      this.stickyHeight=this.stageHeight;
      motionDistance=Math.max(this.track.offsetHeight-this.stickyHeight,1);
      this.start=this.track.getBoundingClientRect().top+scrollY;
    }
    this.distance=motionDistance;
    this.draw();
  }
  onScroll(){
    cancelAnimationFrame(this.raf);
    this.raf=requestAnimationFrame(()=>this.draw());
  }
  draw(){
    if(!this.track||!this.main)return;
    const rawProgress=clamp((scrollY-this.start)/this.distance);
    const mobile=this.mobile;
    const pace=this.number('mobilePace',85);
    const progress=mobile&&this.mobilePinned
      ? Math.pow(rawProgress,pace<=45 ? .72 : pace>=85 ? 1.45 : 1)
      : rawProgress;
    const shrinkStart=mobile?0:clamp(this.number('shrinkStart',0)/100,0,.95);
    const configuredShrinkEnd=this.number('shrinkEnd',25);
    const shrinkEnd=mobile
      ? lerp(.72,.96,clamp((configuredShrinkEnd-15)/45))
      : clamp(configuredShrinkEnd/100,shrinkStart+.01,1);
    const shrink=smooth(shrinkStart,shrinkEnd,progress);
    const startWidth=this.number(mobile?'startWidthM':'startWidthD',100)*this.viewportWidth/100;
    const endWidth=this.number(mobile?'endWidthM':'endWidthD',mobile?74:48)*this.viewportWidth/100;
    const ratio=mobile?this.mobileRatio():1;
    const startHeight=mobile?startWidth*ratio:this.number('startHeightD',100)*this.stageHeight/100;
    const endHeight=mobile?endWidth*ratio:this.number('endHeightD',82)*this.stageHeight/100;
    const radius=this.number('endRadius',42);
    const currentWidth=lerp(startWidth,endWidth,shrink);
    const currentHeight=lerp(startHeight,endHeight,shrink);
    this.style.setProperty('--th-main-w',currentWidth+'px');
    this.style.setProperty('--th-main-h',currentHeight+'px');
    this.style.setProperty('--th-main-r',lerp(0,radius,shrink)+'px');
    this.style.setProperty('--th-main-y',lerp(0,(mobile ? 0 : -.015)*this.stageHeight,shrink)+'px');
    this.style.setProperty('--th-image-s',lerp(1.035,1,shrink));
    const edge=this.number(mobile?'edgeMarginM':'edgeMarginD',mobile?3:1.5);
    this.cards.forEach(card=>{
      if(mobile&&card.dataset.hideMobile==='true'){
        card.style.display='none';
        return;
      }
      card.style.display='';
      let x=Number(card.dataset[mobile?'xM':'xD']);
      let y=Number(card.dataset[mobile?'yM':'yD']);
      const configuredWidth=Number(card.dataset[mobile?'wM':'wD']);
      const cardScale=mobile?clamp(this.number('cardScaleM',80)/100,.7,.85):1;
      const width=mobile?Math.max(configuredWidth*cardScale,18):configuredWidth;
      const rotation=Number(card.dataset[mobile?'rM':'rD']);
      const configuredReveal=clamp(Number(card.dataset.reveal||35)/100,0,.9);
      const reveal=configuredReveal;
      const revealWindow=mobile ? .16 : .14;
      const appeared=smooth(reveal,Math.min(reveal+revealWindow,.98),progress);
      const parallax=Number(card.dataset.parallax||0)*(progress-reveal);
      const entry=card.dataset.entry||'up';
      const entryDistance=mobile?38:70;
      const cardWidth=width/100*this.viewportWidth;
      const cardHeight=cardWidth*1.25;
      const halfWidth=cardWidth/2;
      const halfHeight=cardHeight/2;
      const halfWidthPct=width/2;
      const halfHeightPct=halfHeight/this.stageHeight*100;
      x=clampRange(x,halfWidthPct+edge,100-halfWidthPct-edge);
      y=clampRange(y,halfHeightPct+edge,100-halfHeightPct-edge);
      let translateX=0;
      let translateY=0;
      if(entry==='left')translateX=entryDistance*(1-appeared);
      else if(entry==='right')translateX=-entryDistance*(1-appeared);
      else if(entry==='down')translateY=-entryDistance*(1-appeared);
      else if(entry!=='zoom')translateY=entryDistance*(1-appeared);
      translateY+=parallax;
      const centerX=x/100*this.viewportWidth;
      const centerY=y/100*this.stageHeight;
      const edgeX=edge/100*this.viewportWidth;
      const edgeY=edge/100*this.stageHeight;
      translateX=clampRange(translateX,edgeX+halfWidth-centerX,this.viewportWidth-edgeX-halfWidth-centerX);
      translateY=clampRange(translateY,edgeY+halfHeight-centerY,this.stageHeight-edgeY-halfHeight-centerY);
      card.style.setProperty('--th-x',x+'%');
      card.style.setProperty('--th-y',y+'%');
      card.style.setProperty('--th-w',width+'vw');
      card.style.setProperty('--th-rot',rotation+'deg');
      card.style.setProperty('--th-o',appeared);
      card.style.setProperty('--th-scale',lerp(.72,1,appeared));
      card.style.setProperty('--th-tx',translateX+'px');
      card.style.setProperty('--th-ty',translateY+'px');
    });
  }
}
customElements.define('thiamar-scroll-collage',ThiamarScrollCollage);
})();
